export const TOKENS = {
  dadataToken: process.env.NEXT_PUBLIC_DADATA_API_TOKEN,
  agoraToken: process.env.NEXT_PUBLIC_AGORA_KEY,
};
